// Validasi alpha sebelum Submit HPS Request.
// Kosong = null | undefined | '' | 0 | '0' (0 diblokir sesuai aturan bisnis).

export const isAlphaEmpty = value =>
  value === null ||
  value === undefined ||
  value === '' ||
  value === 0 ||
  value === '0';

// LPG memakai string 'Requested' sebagai placeholder alpha kosong.
export const isLpgAlphaEmpty = value =>
  value === 'Requested' || isAlphaEmpty(value);

const isFob = item =>
  String(item?.incoterm ?? '')
    .trim()
    .toUpperCase() === 'FOB';

const requireDyed = parcel => parcel?.isDyed !== false;
const requireUndyed = parcel => parcel?.isUndyed !== false;

const pushMissing = (missing, parcel, field, label) => {
  missing.push({
    deliveryUnit: parcel?.deliveryUnit || parcel?.id || '-',
    field,
    label,
  });
};

const checkPair = (missing, parcel, source, label, singleAlpha = false) => {
  if (requireDyed(parcel) && isAlphaEmpty(source?.alphaDyedHps)) {
    pushMissing(
      missing,
      parcel,
      'alphaDyedHps',
      singleAlpha ? `${label} (Alpha)` : `${label} (Alpha Dyed)`
    );
  }
  if (
    !singleAlpha &&
    requireUndyed(parcel) &&
    isAlphaEmpty(source?.alphaUndyedHps)
  ) {
    pushMissing(missing, parcel, 'alphaUndyedHps', `${label} (Alpha Undyed)`);
  }
};

// Kumpulkan alpha non-LPG yang masih kosong dari get-delivery-parcel.
// FOB dengan lokasi: cek per lokasi (parent di-override per lokasi di UI).
// Kolom N/A (isDyed/isUndyed false) di-skip.
// singleAlpha (Avtur / High Speed Diesel): hanya Alpha Dyed yang wajib.
export const collectMissingNonLpgAlpha = (parcels = [], options = {}) => {
  const { singleAlpha = false } = options;
  const missing = [];
  for (const parcel of parcels || []) {
    for (const item of parcel?.listData || []) {
      const locations =
        isFob(item) && Array.isArray(item.incotermFOBLocations)
          ? item.incotermFOBLocations
          : [];
      if (locations.length) {
        locations.forEach((loc, idx) => {
          const portName = loc?.name || `location ${idx + 1}`;
          checkPair(missing, parcel, loc, portName, singleAlpha);
        });
        continue;
      }
      const label = item?.route || item?.deliveryBasis || 'row';
      checkPair(missing, parcel, item, label, singleAlpha);
    }
  }
  return missing;
};

// Kumpulkan alpha LPG kosong dari rows tabel (sumber = loadCargoRatioTable).
export const collectMissingLpgAlpha = (rows = []) =>
  (rows || [])
    .filter(row => isLpgAlphaEmpty(row?.alpha))
    .map(row => ({
      deliveryUnit: row?.deliveryUnit || '-',
      field: 'alpha',
      label:
        [row?.port1, row?.cargoRatioLabel, row?.parcelSize]
          .filter(Boolean)
          .join(' / ') || 'row',
    }));

// Gabungkan + dedupe nama delivery unit untuk pesan warning.
export const formatMissingAlphaMessage = (missing = [], emptyLabel = '') => {
  if (!missing.length) return '';
  const units = [...new Set(missing.map(item => item.deliveryUnit))];
  const detail = missing
    .slice(0, 5)
    .map(item => `${item.deliveryUnit}: ${item.label}`)
    .join('; ');
  const more = missing.length > 5 ? ` (+${missing.length - 5} more)` : '';
  return `Please complete ${emptyLabel} before submitting HPS. Missing in ${units.join(', ')} — ${detail}${more}.`;
};
